import { withUserContext, WithUserContextProps, withWorkTask, WithWorkTaskProps } from "@tm/context-distribution"
import { Toolbar } from "@tm/controls"
import { Autocomplete } from "@tm/data"
import { LocalizationProps, withLocalization } from "@tm/localization"
import { CategoryType, SearchFilters } from "@tm/models"
import { connectComponent } from "@tm/morpheus"
import { bindSpecialReactMethods, getCategoryTypeFromUrl, parseQueryString, RouteComponentProps, TmaHelper, withRouter } from "@tm/utils"
import { Component } from "react"
import { SearchType } from "../../business"
import { getBundleParams } from "../../utils"
import { SearchField, Props as SearchFieldProps } from "../_shared/SearchField"
import { Actions, IActions } from "./business"
import { SearchState } from "./business/model"
import { DirectSearchField } from "../_shared/DirectSearchField/DirectSearchField"

type Props = LocalizationProps &
    RouteComponentProps<RouteParams> &
    WithWorkTaskProps &
    WithUserContextProps & {
        state: SearchState
        actions: IActions
    }

type RouteParams = {
    view: string
    searchType: string
}

type State = {
    extendedSearch: boolean
    previousQuery?: string
}

class SearchComponent extends Component<Props, State> {
    private unsubscribe: Function

    constructor(props: Props) {
        super(props)
        bindSpecialReactMethods(this)

        this.state = {
            extendedSearch: false,
        }

        this.unsubscribe = props.actions.init()
        props.actions.loadQueryHistory()
    }

    componentWillUnmount() {
        this.unsubscribe()
    }

    UNSAFE_componentWillMount() {
        const { match, location, actions } = this.props
        const { searchType } = this.props.state
        const { query: parsedQuery, extendedSearch } = parseQueryString(location.search)
        const extendedSearchStatus = extendedSearch === "true"

        // ESLint fix
        let query = parsedQuery

        // HOTFIX
        if (query) {
            query = query.toString().replace(/\+/g, " ")
        }

        actions.setSearchQuery(query ? query.toString() : "")

        if (getCategoryTypeFromUrl(match.url) === "directSearch") {
            if (query && searchType === SearchType.DIRECT) {
                actions.getResultCounts(false)
            }

            this.setState({
                extendedSearch: extendedSearchStatus,
                previousQuery: `${query || ""}`,
            })
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        const { state, actions } = nextProps
        const url = parseQueryString(window.location.search) // Yes 'window.location' is on purpose! 'location' from 'nextProps' mysteriously isn't up to date. If you can fix this, feel free to edit this line of code :)

        if (url.query) {
            // HOTFIX
            url.query = url.query.toString().replace(/\+/g, " ")

            // If search query from url exists and is different, update search field value
            if (url.query !== state.query) {
                actions.setSearchQuery(url.query.toString())
            }
        }

        if (!url.query && state.query) {
            // Reset query
            actions.setSearchQuery("")
        }
    }

    handleChange(query: string) {
        this.setState({ previousQuery: query })
    }

    handleSearch(query: string, searchFilter: SearchFilters) {
        const { actions, match } = this.props
        const { previousQuery } = this.state
        const categoryType = getCategoryTypeFromUrl(match.url)

        // reset the active filter if a new global search is expected
        if (query !== previousQuery) {
            searchFilter = SearchFilters.All
        }

        TmaHelper.Shared.ByArticleAndUniParts.SubmitKeywordSearch(query, categoryType, searchFilter)

        actions.searchArticles(query, categoryType, searchFilter)
    }

    renderSearchField(
        placeholder: string,
        minLengthForSearch: number,
        categoryType: CategoryType,
        extraButton?: JSX.Element,
        getSuggestions?: SearchFieldProps["getSuggestions"]
    ) {
        const { query, hint } = this.props.state

        if (categoryType === "directSearch") {
            return (
                <DirectSearchField
                    value={this.state.previousQuery ?? ""}
                    sx={{ minWidth: "375px", marginTop: 1.8 }}
                    placeholder={placeholder}
                    minimumSearchLength={minLengthForSearch}
                    onChange={this.handleChange}
                    onStartSearchWithQuery={this.handleSearch}
                />
            )
        }

        return (
            <SearchField
                query={query}
                placeholder={placeholder}
                minLengthForSearch={minLengthForSearch}
                getSuggestions={getSuggestions}
                onSearch={this.handleSearch}
                hint={hint}
                extraButton={extraButton}
                autofocus
                activeCategory={categoryType}
                extendedSearch={this.state.extendedSearch}
            />
        )
    }

    renderVehiclePartsSearch() {
        const { vehicle } = this.props.state

        return this.renderSearchField(
            this.props.localization.translateText(998),
            getBundleParams().minimumSearchLength.vehicleSearch,
            "vehicleParts",
            undefined,
            vehicle ? (query) => Autocomplete.getProductGroups(this.props.userContext, query, vehicle.tecDocTypeId) : undefined
        )
    }

    renderUniSearch() {
        return this.renderSearchField(
            this.props.localization.translateText(194),
            getBundleParams().minimumSearchLength.universalSearch,
            "universalParts",
            undefined,
            (query) => Autocomplete.getUniversalProductGroups(this.props.userContext, query)
        )
    }

    renderDirectSearch() {
        return this.renderSearchField(this.props.localization.translateText(138), getBundleParams().minimumSearchLength.directSearch, "directSearch")
    }

    renderCategorySearchField() {
        const categoryType = getCategoryTypeFromUrl(this.props.match.url)

        switch (categoryType) {
            case "vehicleParts":
                return this.renderVehiclePartsSearch()
            case "universalParts":
                return this.renderUniSearch()
            case "directSearch":
                return this.renderDirectSearch()
            default:
                break
        }
    }

    render() {
        return <Toolbar className="tk-parts search">{this.renderCategorySearchField()}</Toolbar>
    }
}

export default connectComponent(Actions, withRouter(withLocalization(withWorkTask(withUserContext(SearchComponent)))))
